import { Button } from './ui';
import { T } from '../styles/tokens';
interface PaginationProps {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
}

export function Pagination({ page, totalPages, total, pageSize, onPageChange, onPageSizeChange }: PaginationProps) {
  if (totalPages <= 1 && total <= pageSize) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  // Generate page numbers to show
  const pages: (number | '...')[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push('...');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) pages.push('...');
    pages.push(totalPages);
  }

  const btnStyle = (active?: boolean): any => ({
    padding: '6px 12px',
    fontSize: 13,
    fontWeight: active ? 700 : 500,
    color: active ? '#fff' : T.textSecondary,
    background: active ? T.primary : T.bgCard,
    border: `1px solid ${active ? T.primary : T.bgHover}`,
    borderRadius: 6,
    cursor: 'pointer',
    transition: 'all 0.15s',
    minWidth: 36,
    textAlign: 'center' as const,
  });

  const disabledStyle: any = { ...btnStyle(), opacity: 0.3, cursor: 'not-allowed', pointerEvents: 'none' };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0', gap: 12, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 13, color: T.textMuted }}>
        {total > 0 ? `${from}-${to} de ${total.toLocaleString('pt-BR')}` : 'Nenhum resultado'}
      </span>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <Button variant="ghost" style={page <= 1 ? disabledStyle : btnStyle()} onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
          Anterior
        </Button>

        {pages.map((p, i) =>
          p === '...' ? (
            <span key={`dots-${i}`} style={{ color: T.textMuted, padding: '0 4px', fontSize: 13 }}>...</span>
          ) : (
            <Button variant="ghost" key={p} style={btnStyle(p === page)} onClick={() => onPageChange(p as number)}>
              {p}
            </Button>
          )
        )}

        <Button variant="ghost" style={page >= totalPages ? disabledStyle : btnStyle()} onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>
          Proximo
        </Button>
      </div>

      {onPageSizeChange && (
        <select
          value={pageSize}
          onChange={(e: any) => onPageSizeChange(parseInt(e.target.value))}
          style={{
            padding: '6px 10px', fontSize: 13, color: T.text,
            background: T.bgCard, border: `1px solid ${T.whiteAlpha8}`,
            borderRadius: 6, cursor: 'pointer',
          }}
        >
          {[25, 50, 100, 200].map(s => <option key={s} value={s}>{s} por pagina</option>)}
        </select>
      )}
    </div>
  );
}
